import React from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  Title,
  TextField,
  DateField,
  ReferenceField,
  FunctionField,
} from 'react-admin';
import { offeringInterestIndicationStatuses } from '../../helpers/mappings';

export default props => (
  <Show
    {...props}
    title={<Title />}
  >
    <TabbedShowLayout>
      <Tab label="Offer Indication of Interest">
        <ReferenceField label="Offer" source="offerId" reference="offerings" linkType sortable={false}>
          <TextField source="name" />
        </ReferenceField>
        <TextField label="First Name" source="subscriberPersonalData.firstName" sortable />
        <TextField label="Last Name" source="subscriberPersonalData.lastName" sortable />
        <TextField label="Email" source="subscriberPersonalData.email" sortable />
        <TextField label="Phone Number" source="subscriberPersonalData.phoneNumber" sortable />
        <TextField label="State Of Residence" source="subscriberPersonalData.stateOfResidence" sortable />
        <TextField label="Investment Range" source="subscriberInvestmentRange" sortable />
        <FunctionField
          label="Indication Status"
          render={record => `${record.status === offeringInterestIndicationStatuses.WATCHING ? 'Indicated' : 'Cancelled Indication'}`}
        />
        <DateField source="createdAt" sortable />
      </Tab>
    </TabbedShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/components/OfferWatch/Show.js